
export function getCategoryMongooseSchema(mongoose, TypeClass){
  let sch = {
    number:{ type: String, required:true},
    fullNumber: {type: String, required:true }  
  }
  
  if(TypeClass.getParentKey()){
    sch[TypeClass.getParentAddress()]= {type: mongoose.ObjectId, ref:TypeClass.getParentKey(), required:true}
  }
  return sch
}

export const SEC_FORM_SCHEMA = [
  {name: 'number', type:'text', required:true},
  {name: 'content', type:'text', required: true }
]

export const RAT_FORM_SCHEMA = [
  {name: 'number', type:'text'},
  {name: 'content', type:'text', required: true }
]

export const CAT_FORM_SCHEMA = [
  {name:'number', type:'text', required:true},
  {name:'fullNumber', type:'text', required:true},
  {name:'content', type:'text', required:true}
]

export const REC_BUDGET_LANG = {
  EUL: 'eul',
  UNIT_TYPE: 'unitType',
  HIGH: 'high',
  LOW: 'low',
  MED: 'med',
  TAG: 'tag'
}
export const recommendation_schema_names = {
  SHORT: 'short',
  CONTENT: 'content',
  ...REC_BUDGET_LANG
}